// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__tb9Jk","inputWrap":"CustomTip_inputWrap__ohhhB"};